import { TFunction } from 'react-i18next'

import { CatalogueGranularity, CatalogueMetricKey } from './catalogueUtils'

// One place for what each metric lens is called and how it is defined, so the
// toggle, the ranked list column header, the chart titles and the chart hover
// footer can never drift apart on the definition of the same number.

const LABEL_KEYS: Record<CatalogueMetricKey, string> = {
  adoption: 'market-analytics:adoption',
  density: 'market-analytics:catalogue_density',
  activeEvents: 'market-analytics:active_live_events',
}

const DESCRIPTION_KEYS: Record<CatalogueMetricKey, string> = {
  adoption: 'market-analytics:tooltip_metric_lens_adoption_description',
  density: 'market-analytics:tooltip_metric_lens_density_description',
  activeEvents: 'market-analytics:tooltip_metric_lens_active_events_description',
}

export function metricLensLabel(metric: CatalogueMetricKey, t: TFunction): string {
  return t(LABEL_KEYS[metric])
}

export function metricLensDescription(metric: CatalogueMetricKey, t: TFunction): string {
  return t(DESCRIPTION_KEYS[metric])
}

const COLUMN_LEVEL_KEYS: Record<CatalogueGranularity, string> = {
  eventCategory: 'market-analytics:tooltip_column_level_event_category',
  eventType: 'market-analytics:tooltip_column_level_event_type',
  blueprint: 'market-analytics:tooltip_column_level_blueprint',
}

// The ranked list's column header reads the same last-month figure the detail
// pages' cards do, so it names the level the rows are at and the last month of
// the period instead of the general "calendar month" the lens definition uses
// for the chart's per-month points.
export function metricLensColumnDescription(metric: CatalogueMetricKey, granularity: CatalogueGranularity, t: TFunction): string {
  const level = t(COLUMN_LEVEL_KEYS[granularity])
  if (metric === 'adoption') return t('market-analytics:tooltip_column_adoption_description', { level })
  if (metric === 'density') {
    return `${t('market-analytics:tooltip_column_density_description', { level })} ${t('market-analytics:detail_stat_density_last_month_note')}`
  }
  return metricLensDescription(metric, t)
}
